import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import CourseDetailsComp from './CourseDetailsComp'

function CourseDetails() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <CourseDetailsComp />
      </div>
    </div>
  )
}

export default CourseDetails
